// Copyright 2018 Sorama B.V.

import { autoinject } from "aurelia-framework";
import {
    GenericMeasurement,
    HolographyProjection,
    HolographyProjectionHologramAnalysisProperties,
    SpatialEnergyCurveSet,
    SpatialEnergyCurveSetCurve,
    SpatialEnergyCurveSetHologramAnalysisProperties,
} from "datatypes/SoramaWebApi";
import { StringExtensions } from "extensions/StringExtensions";
import { Api } from "libraries/WebApi/Api";
import { IWebRequestHandler } from "libraries/WebRequestHandler/IWebRequestHandler";
import { IHolographyHologramProcessingService } from "services/SoundProcessing/IHolographyProcessingService";

@autoinject
export class DatalessCloudSoundProcessingService implements IHolographyHologramProcessingService {
    private static readonly HolographyCall: string = Api.analysis + "/{0}/Holography/Projection/Holograms";
    private static readonly SpatialEnergyCurveCall: string =
        Api.analysis + "/{0}/Holography/SpatialEnergyCurve/Holograms";
    private readonly webRequestHandler: IWebRequestHandler;

    constructor(webRequestHandler: IWebRequestHandler) {
        this.webRequestHandler = webRequestHandler;
    }

    public getHolographyProjections(
        measurement: GenericMeasurement,
        properties: HolographyProjectionHologramAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<HolographyProjection[]> {
        let request = this.webRequestHandler.createPostRequest<HolographyProjection[]>(
            StringExtensions.format(DatalessCloudSoundProcessingService.HolographyCall, measurement.id) +
                (computationProgressCallback ? "?withProgress=true" : ""),
            properties
        );

        if (computationProgressCallback) request = request.withProgress(computationProgressCallback);

        return request.send().then((response) => response.content);
    }

    public getSpatialEnergyCurve(
        measurement: GenericMeasurement,
        properties: SpatialEnergyCurveSetHologramAnalysisProperties,
        computationProgressCallback?: (progress: number) => void
    ): Promise<SpatialEnergyCurveSetCurve> {
        let request = this.webRequestHandler.createPostRequest<SpatialEnergyCurveSet>(
            StringExtensions.format(DatalessCloudSoundProcessingService.SpatialEnergyCurveCall, measurement.id) +
                (computationProgressCallback ? "?withProgress=true" : ""),
            properties
        );

        if (computationProgressCallback) request = request.withProgress(computationProgressCallback);

        return request.send().then((response) => response.content.results[0]);
    }
}
